$.fn.Tabs = function Tabs(options) {
  const $container = $(this);

  options = $.extend({}, options);

  const $tabLinks = $('ul.tabs li', $container);
  const $tabContents = $('.tab_content', $container);

    // init tab state
  $tabContents.hide().first().show();

  $tabLinks.click(function click(e) {
    e.preventDefault();

    $('ul.tabs li, .tabAccord', $container).removeClass('active');

    $(this).addClass('active');

    $tabContents.hide();

    const $activeTab = $(`#${$(this).data('tabid')}`);

    $activeTab.fadeIn(400, 'swing', () => {
      if (options.activate && typeof (options.activate) === 'function') {
        options.activate();
      }
    }).prev('.tabAccord').addClass('active');

    productCarousel($activeTab);
  });

  $('.reviews-link').click(() => {
        // check if there is a reviews tab on the page
    const $reviewTabContent = $('#ReviewsTab');
    const $reviewTabLink = $tabLinks.filter(function filter() {
      return `#${$(this).data('tabid')}` === 'ReviewsTab';
    });

    if ($reviewTabContent.length && $reviewTabLink.length) {
      $reviewTabLink.click();
    }
  });

    // product tabs accordion
  if ($(window).width() < 767) {
    $tabContents.hide();
    productCarousel();
  }

  $(window).resize(() => {
    if ($(window).width() < 767) {
      $tabContents.hide();
      $('.tabAccord', $container).removeClass('active');
    } else if ($(window).width() > 767) {
      const $currentTabId = $('ul.tabs li.active', $container).data('tabid');
      $(`#${$currentTabId}`).show();
    }
  });

  $('.tabAccord', $container).click(function click() {
    $(this).toggleClass('active');
    const $tabContent = $(this).next('.tab_content').slideToggle();
    productCarousel($tabContent);
    return false;
  });

  if ($(window).width() > 767) {
    productCarousel();
  }

    // get the tabid from the location.hash value and select that tab
  const $selectedTab = $tabLinks.filter(function filter() {
    return `#${$(this).data('tabid')}` === window.location.hash;
  });

  if ($selectedTab.length) {
    $selectedTab.click();
  }

  $(window).on('hashchange', () => {
    // eslint-disable-next-line no-shadow
    const $selectedTab = $tabLinks.filter(function filter() {
      return `#${$(this).data('tabid')}` === window.location.hash;
    });

    if ($selectedTab.length) {
      $selectedTab.click();
      window.scrollTo(0, $selectedTab.position().top);
    }
  });
};

function productCarousel($tabContent) {
  const options = {
    scroll: 1,
    responsive: true,
    height: 'variable',
    items: {
      width: 250,
      height: 'variable',
      visible: {
        min: 1,
        max: 2,
      },
    },
    swipe: {
      onTouch: true,
      onMouse: false,
    },
    circular: false,
    infinite: false,
    auto: false,
  };


  if ($tabContent !== undefined) {
    $('.productSlider').each(function each() {
      const $carousel = $('.foo3', this);
      if ($carousel.length) {
        $carousel.carouFredSel($.extend(options, {
          prev: {
            button: $('.prevSlide', this),
          },
          next: {
            button: $('.nextSlide', this),
          },
        }));
      }
    });
  } else {
    $('.productSlider', $tabContent).each(function each() {
      const $carousel = $('.foo3', this);

      if ($carousel.length) {
        $carousel.carouFredSel($.extend(options, {
          prev: {
            button: $('.prevSlide', this),
          },
          next: {
            button: $('.nextSlide', this),
          },
        }));
      }
    });
  }
}
